import AuthContext from "../../utilis/contexts/AuthContext";
import {useContext} from "react";
import {Validation} from "../../utilis/tools/validation";
import {Form, Input} from "antd";
import { PhoneOutlined, MobileOutlined} from "@ant-design/icons";
type Props={
    validationSchema:any
    data?:any
}
const DefaultForm = (props:Props) => {
    //for portal
    const {validationSchema,data}=props;
    const authContext=useContext(AuthContext)
    if(authContext.authenticated){
        return  null
    }
    return   <>

        <Form.Item
            label="تلفن ثابت"
            name="tel"

            rules={[Validation(validationSchema)]}
        >
            <Input size="large" prefix={<PhoneOutlined className="text-gray-50"/>}
                   placeholder="مثلا ۰۱۱۳۵۷۵۵۳۴۳"/>
        </Form.Item>

        <Form.Item
            label="تلفن همراه"
            name="mobile"
            initialValue={authContext.authenticated?data.cellphone :''}
            rules={[Validation(validationSchema)]}
        >
            <Input size="large" placeholder="مثلا ۰۹۲۱۰۹۱۳۲۳۲"
                   prefix={<MobileOutlined className="text-gray-50"/>}/>
        </Form.Item>
        </>
}
export default DefaultForm;